/** enum with color theme of button */
var ThemePalette;
(function (ThemePalette) {
    ThemePalette["accent"] = "accent";
    ThemePalette["primary"] = "primary";
    ThemePalette["secondary"] = "secondary";
    ThemePalette["third"] = "third";
    ThemePalette["fourth"] = "fourth";
    ThemePalette["fifth"] = "fifth";
    ThemePalette["sixth"] = "sixth";
})(ThemePalette || (ThemePalette = {}));
/** enum with type of button */
var ButtonType;
(function (ButtonType) {
    ButtonType["button"] = "button";
    ButtonType["submit"] = "submit";
    ButtonType["reset"] = "reset";
})(ButtonType || (ButtonType = {}));
export { ButtonType as B, ThemePalette as T };
